import { api } from 'redux/api/index.api';
import { getProjectsServiceVersion } from 'utils/constants';

export const projectsApi = api.injectEndpoints({
  endpoints: builder => ({
    fetchProjects: builder.query({
      query: ({ organizationId, workspaceIds = [] }) => ({
        url: `${getProjectsServiceVersion()}/projects/filters`,
        params: {
          business_organization_id: organizationId,
          limit: 1000,
          offset: 0,
        },
        body: {
          workspace_ids: workspaceIds,
        },
        method: 'POST',
      }),
      providesTags: ['Project'],
    }),
    fetchProjectInfo: builder.query({
      query: ({ projectId }) => ({
        url: `projects/${projectId}`,
        method: 'GET',
      }),
    }),
    fetchActivities: builder.query({
      query: ({ projectId, limit = 100 }) => ({
        url: `v2.0/projects/${projectId}/activities`,
        params: {
          limit,
        },
        method: 'GET',
      }),
      providesTags: ['Activities'],
    }),
  }),
  overrideExisting: 'throw',
});

export const {
  useFetchProjectsQuery,
  useFetchProjectInfoQuery,
  useFetchActivitiesQuery,
} = projectsApi;
